import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { spacing, colors, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	multiEmployeeSelector: {
		position: 'relative',
	},
	multiEmployeeSelectorDisabled: {
		opacity: 0.6,
		cursor: 'not-allowed',
	},
	multiEmployeeSelectorContentDisabled: {
		cursor: 'not-allowed',
	},
	multiEmployeeSelectorDropdown: {
		position: 'relative',
	},
	multiEmployeeSelectorPopover: {
		zIndex: 10000, // Ensure dropdown appears above advanced settings popover (z-index: 5)
	},
	multiEmployeeSelectorDropdownContent: {
		position: 'absolute',
		zIndex: 10000, // Increased from 1000 to ensure it appears above popovers (z-index: 5)
		backgroundColor: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
		maxHeight: 200,
		overflowY: 'auto',
		minWidth: 250,
		margin: `${spacing.xs}px 0`, // Add margin for better separation
		padding: `${spacing.xs}px 0`, // Add padding inside dropdown
	},
	multiEmployeeSelectorContent: {
		// Match standard text-field() styling
		background: colors.background.main,
		borderRadius: common.borderRadius,
		border: common.border,
		boxSizing: 'border-box',
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		padding: spacing.sm, // Use theme spacing
		cursor: 'text',
		width: 300, // Fixed width to prevent container from growing
		maxWidth: 300, // Ensure it doesn't exceed this width
		maxHeight: 120, // Max height to prevent container from growing too tall
		overflowY: 'auto', // Enable vertical scrolling when content exceeds max height
		overflowX: 'hidden',
	},
	multiEmployeeSelectorTokens: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: spacing.sm, // Use theme spacing
		alignItems: 'center',
		padding: `${spacing.xs}px 0`, // Use theme spacing
	},
	multiEmployeeSelectorTokenContainerInput: {
		display: 'flex',
		minWidth: 150,
		flex: 1,
		fontSize: typography.fontSizes.sm,
		border: common.border,
		borderRadius: common.borderRadius,
		// background: 'transparent',
		outline: 'none',
		color: colors.text.main,
		padding: `${spacing.xs}px ${spacing.sm}px`,
		height: 24,
		'&::placeholder': {
			color: colors.text.light,
		},
		'&:focus': {
			borderColor: colors.primary.main,
			boxShadow: `0 0 0 2px ${colors.primary.light}`,
		},
	},
	multiEmployeeSelectorToken: {
		display: 'flex',
		alignItems: 'center',
		maxWidth: 200,
	},
	multiEmployeeSelectorEmployee: {
		padding: `${spacing.sm}px ${spacing.md}px`, // Increased padding for better spacing
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		borderRadius: common.borderRadius,
		backgroundColor: colors.background.light,
		margin: `0 ${spacing.xs}px`, // Add horizontal margin
	},
	multiEmployeeSelectorEmployeeHover: {
		backgroundColor: colors.hover.light,
	},
	multiEmployeeSelectorEmployeeHighlighted: {
		backgroundColor: colors.hover.light,
	},
	multiEmployeeSelectorEmployeeAvatar: {
		marginRight: spacing.sm, // Use theme spacing
		width: 32,
		height: 32,
	},
	multiEmployeeSelectorEmployeeDetails: {
		flex: 1,
		minWidth: 0,
	},
	multiEmployeeSelectorEmployeeDetailsName: {
		fontWeight: typography.fontWeights.standard,
		color: colors.text.main,
		marginBottom: spacing.xs, // Use theme spacing
	},
	multiEmployeeSelectorEmployeeDetailsEmail: {
		fontSize: typography.fontSizes.xs,
		color: colors.text.light,
	},
	multiEmployeeSelectorNoMatches: {
		padding: `${spacing.md}px ${spacing.lg}px`, // Increased padding to match employee items
		color: colors.text.light,
		fontStyle: 'italic',
		backgroundColor: colors.background.light,
		margin: `0 ${spacing.xs}px`, // Add horizontal margin to match employee items
	},
	multiEmployeeSelectorContentFocus: {
		borderColor: colors.primary.main,
		boxShadow: `0 0 0 2px ${colors.primary.light}`, // Focus ring
	},
});
